import { useState, useEffect } from "react";
import { SemRushTransport } from "src/app/transports/semRush";
import { TLangType } from "src/app/types/LangType";
import { ISemRushKeywords } from "src/app/types/semrush";

const useSemRushKeywords = (
    keyword?: string,
    numberOfKeywords?: number,
    lang?: TLangType,
    initialRequest = true
) => {
    const [keywords, setKeywords] = useState<Array<ISemRushKeywords>>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | undefined>();

    const fetch = (
        fKeyword?: string,
        fNumberOfKeywords?: number,
        fLang?: TLangType,
        setSemRushKeywordsToData?: (
            semRushKeywords: ISemRushKeywords[] | false,
            error: string | null
        ) => void
    ) => {
        if (!fKeyword) {
            setError("No keyword Found");
            setSemRushKeywordsToData && setSemRushKeywordsToData(false, "No keyword Found");
            return;
        }
        if (!fNumberOfKeywords) {
            setError("Invalid number of keywords");
            setSemRushKeywordsToData &&
                setSemRushKeywordsToData(false, "Invalid number of keywords");
            return;
        }
        if (!fLang) {
            setError("invalid Lang");
            setSemRushKeywordsToData && setSemRushKeywordsToData(false, "invalid Lang");
            return;
        }

        setLoading(true);
        SemRushTransport.getKeywords(fKeyword, fNumberOfKeywords, fLang)
            .then((res) => {
                if (!Array.isArray(res)) {
                    setError(res);
                } else if (res[0].error) {
                    setError(res[0].error);
                    setSemRushKeywordsToData && setSemRushKeywordsToData(false, res[0].error);
                } else {
                    setSemRushKeywordsToData && setSemRushKeywordsToData(res, null);
                    setKeywords(res);
                    setError(undefined);
                }
            })
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    };

    const refresh = (
        rKeyword: string,
        rNumberOfKeywords: number,
        rLang: TLangType,
        setSemRushKeywordsToData?: (
            semRushKeywords: ISemRushKeywords[] | false,
            error: string | null
        ) => void
    ) => {
        if (!loading) fetch(rKeyword, rNumberOfKeywords, rLang, setSemRushKeywordsToData);
    };

    useEffect(() => {
        if (initialRequest) fetch(keyword, numberOfKeywords, lang);
    }, []);

    return { keywords, refresh, error, loading };
};

export default useSemRushKeywords;
